<template>
  <div class="c-batch g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 选择投放账号 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 设置创意 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="md-options"></Icon> 批量确认 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler :name="item.href" v-for="item in subModules" :key="item.id">
        <template v-if="item.href === 'submit_base'">
          <Row class="c-batch-head">
            <Col span="24">
              <span :style="{ marginRight: '12px' }"><b>批量计划配置</b></span>
              <span
                >共计：账号数 <span class="g-error-text">{{ lenAccount }}</span> 个，计划数
                <span class="g-error-text">{{ submitData.length }}</span> 条</span
              >
            </Col>
          </Row>
          <Tabs v-model="current" type="card" @on-click="changeTabs">
            <div class="c-submit-control g-pull-right" slot="extra">
              <el-input-number v-model="num" controls-position="right" :precision="0" :min="1" :max="50" />
              <Button type="primary" :disabled="!isBatch" @click="batchAdd">批量添加计划</Button>
              <Button @click="batchDel">批量删除</Button>
            </div>
            <TabPane v-for="(a, id) of bat_accounts" :label="accountTitle(a.name)" :name="a.name" :key="id"> </TabPane>
          </Tabs>
          <!-- 表格组件 -->
          <batch-table
            ref="rangeTable"
            :data="tableData"
            :loading="loading"
            :campagin="isCampagin"
            :dynwords="dynwords"
            :app-type="appType"
            :show-mini-program-page="landing_type === 'LINK' && platform === 3"
            :is-union="isUnion"
            @blur-budget="changeBudget"
            @on-change="changeInputLen"
            @on-select="selectCheckBox"
            @on-select-all="selectAll"
            @on-batch="batchAll"
            @on-copy="copySubmit"
            @on-delete="delSubmit"
            @on-trend="appendTrend"
            @on-delete-trend="delTrend"
            @on-selection="changeSelection"
          >
          </batch-table>
        </template>
      </moduler>
    </div>

    <!-- 提交 -->
    <div class="c-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <div class="c-batch-foot">
            <span class="b-state">计划状态</span>
            <i-switch v-model="batch.operation" size="large" true-value="enable" false-value="disable">
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
            </i-switch>
          </div>
          <Button type="default" @click.stop="back">上一步</Button>
          <Button type="primary" :loading="loading" :disabled="disabled" @click.stop="submit">
            <span v-if="loading">提交中...</span>
            <span v-else>完成</span>
          </Button>
        </Col>
      </Row>
    </div>

    <!-- 批量添加弹窗 -->
    <set-batch
      ref="setBatch"
      v-model="model"
      :loading="auding"
      :type="seType"
      :data="setData"
      :media="media"
      :dis-crowd="setDisCrowd"
      @on-select="asynSetBatch"
      @on-clear="clearSetData"
      @on-delete="deleteSetData"
    />

    <!-- 小程序转化列表配置 -->
    <el-dialog title="配置转化追踪" :close-on-click-modal="false" :visible.sync="miniProgramConvertVisible" width="900px">
      <TransFeed
        v-model="appTransIdByAccount"
        :trans-list="miniProgramTransList"
        :accounts="sources.account.filter((ac) => ac.name === current)"
        @account-change="getConvertByAccount"
      ></TransFeed>
      <div slot="footer">
        <el-button @click="onMiniProgramConvertCancel">取 消</el-button>
        <el-button type="primary" @click="onMiniProgramConvertConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 小程序落地页配置 -->
    <el-dialog title="配置落地页" :close-on-click-modal="false" :visible.sync="miniProgramPageVisible" width="400px">
      <el-input v-model="miniProgramPageUrl" placeholder="请输入落地页地址"></el-input>
      <p style="color: red; font-size: 12px" v-if="!miniProgramPageUrlValid">地址不合法</p>
      <div slot="footer">
        <el-button @click="onMiniProgramPageCancel">取 消</el-button>
        <el-button type="primary" @click="onMiniProgramPageConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 素材检测弹窗 -->
    <result-image v-model="ruleModel" :table-data="ruleData" :loading="ruling" @submit="postRequest" @advice="postAdvicest" />
  </div>
</template>
<script>
import opts from './batch-opts.js'
export default opts
</script>
<style lang="scss" scoped>
.c-batch {
  height: 100%;
  padding-bottom: 0;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 108px);

    .c-moduler {
      height: calc(100% - 12px);
      padding: 12px 16px;

      ::v-deep .c-moduler-range {
        height: 100%;

        > .c-moduler-title {
          margin-bottom: 8px;
        }
      }
    }
  }

  .c-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .c-batch-head {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;

    span {
      line-height: 32px;
    }
  }

  .c-submit-control {
    button {
      margin-left: 5px;
    }
  }

  .c-batch-foot {
    line-height: 20px;
    display: inline-flex;
    align-items: center;

    .b-state {
      padding-right: 12px;
    }
  }
}
</style>
